<template>
  <div class="feature" v-scroll-animate>
    <div class="field-icon">
      <img :src="feature.image" alt="">
    </div>
    <div class="field-box-title heading-3-bold" v-html="feature.title"></div>

    <div v-for="value in feature.values" class="field-box-row">
      <div class="asset-container">
        <img src="../../assets/icons/accept-red.svg" alt="">
      </div>
      <div class="paragraph-1-large" v-html="value.name"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Feature',
  props: {
    feature: {
      type: Object
    }
  },

}
</script>

<style lang="scss">
@import "Feature";
</style>
